import Breadcrumbs from './components/Breadcrumbs';

export default Breadcrumbs;
